<div class="footer-frame">
    <div class="position-relative">
        <a routerLink="/" class="footer-frame-logo">
            <img src="assets/img/logo_opco_ep_blanc.png" alt="Logo OPCO EP" />
        </a>
        <span class="appVersion appVersion__footer" [ngClass]="{'appVersion__footer--snapshot' : !!isSnapshot}">{{formattedVersion}}</span>
    </div>
    <div class="footer-links">
        <div class="footer-links-mobile">
            @if(isLoggedIn) {
            <div class="footer-links-item footer-links-mobile">
                <a routerLink="/cgu" class="footer-links-text">CGU</a>
            </div>
            <div class="footer-links-item footer-links-mobile">
                <a href="/cggc" target="_blank" class="footer-links-text">CGGC</a>
            </div>
            }
            <div class="footer-links-item">
                <a routerLink="/mentions-legales" class="footer-links-text">Mentions légales</a>
            </div>
            <div class="footer-links-item">
                <a routerLink="/politique-de-confidentialite" class="footer-links-text">Politique de confidentialité</a>
            </div>
        </div>
        <div class="footer-links-mobile">
            <div class="footer-links-item">
                <a routerLink="/cookies" class="footer-links-text">Cookies</a>
            </div>
            @if(isLoggedIn) {
            <div class="footer-links-item">
                <a routerLink="/autres-portails" class="footer-links-text">Autres portails</a>
            </div>
            }
        </div>
        <div class="footer-links-mobile">
            <div class="footer-links-item">
                <a href="https://www.opcoep.fr/vigilance-fraudes" class="footer-links-text" target="_blank">Vigilance
                    fraudes</a>
            </div>
        </div>
    </div>
    <div class="social-media-frame">
        <div class="social-media-frame-item social-media-frame-item__linkedin">
            <a href="https://fr.linkedin.com/company/opco-ep" target="_blank" class="social-media-frame-icon">
                <i class="pi pi-linkedin"></i>
            </a>
        </div>
        <div class="social-media-frame-item">
            <a href="https://www.facebook.com/OPCOEP" target="_blank" class="social-media-frame-icon">
                <i class="pi pi-facebook social-media-frame-icon"></i>
            </a>
        </div>
        <div class="social-media-frame-item">
            <a href="https://www.youtube.com/channel/UCDtPj4JwltQ7eGcvONk7Bdg" target="_blank"
                class="social-media-frame-icon">
                <i class="pi pi-youtube social-media-frame-icon"></i>
            </a>
        </div>
    </div>
</div>